<template>
  <div class="grid-view">
    <div class="main-content voucher-list">
      <el-form :inline="true" label-width="60px" label-position="left" style="margin-top: 4px;">
        <div class="app-main-inner-row" style="padding: 0; margin-left: 10px;justify-content: flex-start;">
          <el-form-item :label="$t('CargoMsg.Cargo_VoucherPeriod')" class="el-form-item">
            <el-select
              v-model="searchForm.voucherPeriodStarKey"
              filterable
              style="width:150px;"
              @change="chargeVoucherPeriodStar"
            >
              <el-option
                v-for="item in voucherPeriodList"
                :key="item.uuid"
                :label="item.label"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_To')" label-width="60px">
            <el-select
              v-model="searchForm.voucherPeriodEndKey"
              filterable
              style="width:150px;"
              @change="chargeVoucherPeriodEnd"
            >
              <el-option
                v-for="item in voucherPeriodList"
                :key="item.uuid"
                :label="item.label"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessDate')">
            <el-date-picker
              v-model="searchForm.businessDateStar"
              type="date"
              style="width:100px;"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_To')" label-width="24px">
            <el-date-picker
              v-model="searchForm.businessDateEnd"
              type="date"
              style="width:100px;"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Customer')">
            <cargo-advance-select
              :callback-params="{key:'customerId'}"
              :default-value="searchForm.customerId"
              :select-type="selectTypeNames.basic_data_Company"
              callback-method-type="value"
              filterable
              style="width: 200px;"
              @parentCallBack="selectChangeHandler"
            />
          </el-form-item>
        </div>
        <div class="app-main-inner-row" style="padding: 0; margin-left: 10px;justify-content: flex-start;">
          <el-form-item :label="$t('CargoMsg.Cargo_Post')">
            <cargo-advance-select
              :callback-params="{key:'post'}"
              :default-value="searchForm.post"
              :select-type="selectTypeNames.local_cache_SystemConstants$POST_SOURCES"
              callback-method-type="value"
              filterable
              style="width: 150px;"
              @parentCallBack="selectChangeHandler"
            />
          </el-form-item>
          <el-form-item :label="salesPersonTitle">
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_User"
              :default-value="searchForm.salesPerson"
              :cache="false"
              tag-name="chineseName"
              style="width:150px;"
              :static-options="userArray"
              @parentCallBack="salesPersonChangeHandler"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_RefundOfLclBusiness')" label-width="100px">
            <el-radio-group v-model="searchForm.refundOfLclBusiness">
              <el-form-item style="width: 260px;">
                <el-radio :label="-1" style="float:left">{{ $t('FinanceManage.All') }}</el-radio>
                <el-radio :label="1" style="float:left">{{ $t('FinanceManage.Yes') }}</el-radio>
                <el-radio :label="0" style="float:left">{{ $t('FinanceManage.No') }}</el-radio>
              </el-form-item>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryPageHandler(false)">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          </el-form-item>
        </div>
        <div />
      </el-form>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="0211218"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
        <div style="padding-top: 10px">
          <el-form label-width="60px" label-position="left">
            <div class="el-form-item-wrapper" style="float:right">
              <span style="font-weight:bold"> {{ $t('CargoMsg.Cargo_TotalAmountP') + lbAmountSum }} {{ $t('CargoMsg.Cargo_TotalCommissionAmountP') + lbCommissionAmountSum }}</span>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import ColumnUtils from '@/utils/ColumnUtils'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { getBusinessCommissionFunc } from '@/api/financeManage/businessCommission'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { formatNumberToThousands } from '@/utils'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import lang from '@/lang'

export default {
  name: 'BusinessCommissionPage',
  components: { AccountSetPopup, cargoUserSelect, cargoAdvanceSelect },
  props: {
    accountSet: { type: Object, required: false, default: null } // 账套
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      accountSetPopup: { visible: false, mode: 'office' },
      lbAmountSum: '',
      lbCommissionAmountSum: '',
      userArray: [], // 用户集合
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        getRowStyle: (params) => {
          const row = params.data
          if (row.pxtf) {
            return { 'color': '#212BE1FF' }
          }
        },
        pagination: false,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_VoucherPeriod'), field: 'period', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_VoucherNo'), field: 'documentNo', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_JobNo'), field: 'jobNo', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_Customer'), field: 'customerName', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_Sales'), field: 'salesName', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_CustomerService'), field: 'csrName', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_Operation'), field: 'opName', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffStatus'), field: 'clearStatus', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'businessDate', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_ReceivedDate'), field: 'payReceiveDate', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_Aging'), field: 'days', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_Amount'), field: 'creditRmb', width: 120,
          valueFormatter: params => {
            const amount = ColumnUtils.formatNumber(params.value, 2, true)
            if (!isNaN(amount) && amount > 0) {
              return formatNumberToThousands(amount, 2)
            }
            return amount
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CommissionPercentage'), field: 'commissionRate', width: 120,
          valueFormatter: params => {
            if (params.value && params.value > 0) {
              return ColumnUtils.formatNumber(params.value, 2) + '%'
            }
            return ''
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CommissionAmount'), field: 'commissionAmount', width: 120,
          valueFormatter: params => {
            const amount = ColumnUtils.formatNumber(params.value, 2)
            if (params.data.customerName === '合计') {
              return formatNumberToThousands(amount, 2)
            } else {
              if (amount !== '0.00') {
                return formatNumberToThousands(amount, 2)
              }
            }
            return ''
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_IncoTerm'), field: 'incoTerm', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_RefundOfLclBusiness'), field: 'pxtf', width: 120,
          valueFormatter: params => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ReceiveAmount'), field: 'receiveAmountRmb', width: 120,
          valueFormatter: params => {
            const receiveAmountRmb = ColumnUtils.formatNumber(params.value, 2, true)
            if (!isNaN(receiveAmountRmb) && receiveAmountRmb > 0) {
              return formatNumberToThousands(receiveAmountRmb, 2)
            }
            return receiveAmountRmb
          }
        }
      ],
      rowData: [],
      voucherPeriodList: [],
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      salesPersonTitle: lang.t('CargoMsg.Cargo_SalesPerson'),
      searchForm: {
        voucherPeriodStarKey: null,
        voucherPeriodEndKey: null,
        voucherPeriodStar: null,
        voucherPeriodEnd: null,
        businessDateStar: null,
        businessDateEnd: null,
        customerId: null,
        post: 0,
        salesPerson: null,
        refundOfLclBusiness: -1
      }
    }
  },
  computed: {

  },
  watch: {
    accountSet(value) {
      this.accountSet = value
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.clear()
      if (this.accountSet) {
        this.voucherPeriodList = []
        for (const p of this.accountSet.fiscalPeriod) {
          p.label = p.year + this.$t('FinanceManage.Year') + p.month + this.$t('FinanceManage.Period')
          p.sort = new Date(p.beginDate).getTime()
          this.voucherPeriodList.push(p)
        }
        this.localeCompareHandler(this.voucherPeriodList)
        this.fiscalPeriod()
        this.queryUserList()
        this.searchForm.voucherPeriodStarKey = this.fiscalPeriod().uuid
        this.searchForm.voucherPeriodEndKey = this.fiscalPeriod().uuid
        this.searchForm.refundOfLclBusiness = -1
      }
    },
    // 倒序排列
    localeCompareHandler(list) {
      return list.sort((a, b) => b.sort - a.sort)
    },
    clear() {
      this.searchForm = PriceUtils.resetFilter(this.searchForm)
      this.rowData = []
      this.lbAmountSum = ''
      this.lbCommissionAmountSum = ''
    },
    fiscalPeriod() {
      if (this.accountSet) {
        return this.accountSet.currentFiscalPeriod
      }
      return null
    },
    chargeVoucherPeriodStar(event) {
      this.searchForm.voucherPeriodStarKey = event
    },
    chargeVoucherPeriodEnd(event) {
      this.searchForm.voucherPeriodEndKey = event
    },
    queryPageHandler() {
      if (this.accountSet) {
        const obj = {}
        obj.year = this.fiscalPeriod().year
        obj.accountSet = this.accountSet.uuid
        obj.businessDateStart = this.searchForm.businessDateStar
        obj.businessDateEnd = this.searchForm.businessDateEnd
        if (this.searchForm.voucherPeriodStarKey) {
          this.searchForm.voucherPeriodStar = this.voucherPeriodList.find(item => {
            return item.uuid === this.searchForm.voucherPeriodStarKey
          })
        }
        if (this.searchForm.voucherPeriodEndKey) {
          this.searchForm.voucherPeriodEnd = this.voucherPeriodList.find(item => {
            return item.uuid === this.searchForm.voucherPeriodEndKey
          })
        }
        if (this.searchForm.voucherPeriodStar) {
          obj.documentMonthStart = this.searchForm.voucherPeriodStar.month
          obj.yearSearchStart = this.searchForm.voucherPeriodStar.year
        } else {
          obj.documentMonthStart = this.fiscalPeriod().month
          obj.yearSearchStart = this.fiscalPeriod().year
        }
        if (this.searchForm.voucherPeriodEnd) {
          obj.documentMonthEnd = this.searchForm.voucherPeriodEnd.month
          obj.yearSearchEnd = this.searchForm.voucherPeriodEnd.year
        } else {
          obj.documentMonthEnd = this.fiscalPeriod().month
          obj.yearSearchEnd = this.fiscalPeriod().year
        }
        if (typeof obj.yearSearchStart === 'undefined' && typeof obj.yearSearchEnd === 'undefined') {
          this.$message.warning(this.$t('FinanceManage.PleaseSelectVoucherRange'))
          return
        }
        obj.periodStart = String(obj.yearSearchStart) + StrUtils.strRightRepeat('0', 2, String(obj.documentMonthStart))
        obj.periodEnd = String(obj.yearSearchEnd) + StrUtils.strRightRepeat('0', 2, String(obj.documentMonthEnd))
        // 相同年
        if (this.searchForm.voucherPeriodStar && this.searchForm.voucherPeriodEnd && this.searchForm.voucherPeriodStar.year !== this.searchForm.voucherPeriodEnd.year) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PSFPOTSY'))
          return
        }
        // 客户
        if (this.searchForm.customerId) {
          obj.customer = this.searchForm.customerId
        }
        // 岗位(销售=0、操作=1、客服=2)
        obj.role = this.searchForm.post
        // 人员
        if (this.searchForm.salesPerson) {
          obj.userId = this.searchForm.salesPerson
        }
        // 是否拼箱退费 (全部=-1、是=1、否=0)
        obj.pxtf = this.searchForm.refundOfLclBusiness

        this.loading = getLoading()
        getBusinessCommissionFunc({ conditionMap: obj }).then(res => this.handleQueryData(res)).catch((err) => {
          this.$message.error(err)
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data
      // 金额/提成金额合计
      let amountSum = 0.0
      let commissionAmountSum = 0.0
      for (const item of this.rowData) {
        if (item.customerName !== '合计') {
          if (item.creditRmb) {
            amountSum += item.creditRmb
          }
          if (item.commissionAmount) {
            commissionAmountSum += item.commissionAmount
          }
        }
      }

      this.lbAmountSum = formatNumberToThousands(ColumnUtils.formatNumber(amountSum, 2), 2)
      this.lbCommissionAmountSum = formatNumberToThousands(ColumnUtils.formatNumber(commissionAmountSum, 2), 2)
      this.loading.close()
    },
    async queryUserList() {
      this.userArray = await getSpecificBasicData(TYPE_NAMES.basic_data_User)
    },
    selectChangeHandler(params) {
      this.searchForm[params.key] = params.value
      if (params.key === 'post') {
        if (params.value === 0) {
          this.salesPersonTitle = this.$t('CargoMsg.Cargo_SalesPerson')
        } else if (params.value === 1) {
          this.salesPersonTitle = this.$t('CargoMsg.Cargo_CSR')
        } else if (params.value === 2) {
          this.salesPersonTitle = this.$t('CargoMsg.Cargo_CustomerService')
        }
      }
    },
    salesPersonChangeHandler(params) {
      this.searchForm.salesPerson = params.value
    }
  }
}
</script>
